<template>
	<v-list-item
		style="border: 1px solid #e0e0e0; border-radius: 5px"
	>
		<v-list-item-icon class="mr-3">
			<v-icon :color="user.color">person</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{user.name}}</strong>
				<v-chip v-if="user.deactivated" small class="ml-1" text-color="white" color="grey"><translate>Deactivated</translate></v-chip>
			</v-list-item-title>
			<v-list-item-subtitle></v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters align="center">
				<v-chip small class="mr-1" text-color="white" :color="getColor()">{{getRole()}}</v-chip>
				<template v-if="user.role == 'terapeut'">
					<v-tooltip v-if="user.deactivated" top>
						<template v-slot:activator="{ on }">
							<v-btn icon v-on="on" @click="$emit('activate-user', user)">
								<v-icon color="primary">mdi-account-check</v-icon>
							</v-btn>
						</template>
						<span v-translate key="activate">Activate</span>
					</v-tooltip>
					<v-tooltip v-else top>
						<template v-slot:activator="{ on }">
							<v-btn icon v-on="on" @click="$emit('deactivate-user', user)">
								<v-icon color="primary">mdi-account-remove</v-icon>
							</v-btn>
						</template>
						<span v-translate key="deactivate">Deactivate</span>
					</v-tooltip>
				</template>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" @click="$emit('edit-user', user)">
							<v-icon color="primary">edit</v-icon>
						</v-btn>
					</template>
					<span v-translate key="edit">Edit</span>
				</v-tooltip>
				<v-tooltip v-if="user.role != 'manager' && user.id != 23" top>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" @click="showDeleteUser = true">
							<v-icon color="primary">delete</v-icon>
							<DeleteConfirmationDialog v-model="showDeleteUser" item="user" @delete="$emit('delete-user',user); showDeleteUser=false" />
						</v-btn>
					</template>
					<span v-translate key="remove">Remove</span>
				</v-tooltip>
			</v-row>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "UserItem",
  props: ["user"],
  components: {
    DeleteConfirmationDialog
  },
  data: () => ({
    showDeleteUser: false
  }),
  methods: {
    getColor() {
			var color = "";
			if (this.user.role == "admin") {
				color = "black";
			}
			else if (this.user.role == "manager") {
				color = "red";
			} else if (this.user.role == "terapeut") {
				color = "blue";
			} else {
				color = "primary";
			}
			return color;
    },
    getRole() {
			var role = "";
			if (this.user.role == "admin") {
				role = this.$gettext("Admin");
			}
			else if (this.user.role == "manager") {
				role = this.$gettext("Manager");
			} else if (this.user.role == "terapeut") {
				role = this.$gettext("Health Professional");
			} else {
				role = this.$gettext("Receptionist");
			}
			return role;
    }
  }
}
</script>